const { dateToTimestamp, getNumber } = require('../utils');
export default [
    {
        title: '用户',
        type: 'string',
        dataIndex: 'name',
        key: 'name',
        width: '8%',
        sorter: (a, b) => getNumber(a.name) - getNumber(b.name),
        defaultSortOrder: 'ascend',
    },
    {
        title: '演唱会',
        type: 'string',
        dataIndex: 'concert',
        key: 'concert',
        width: '10%',
        sorter: (a, b) => a.concert.localeCompare(b.concert),
        editable: true,
    },
    {
        title: '时间',
        type: 'string',
        dataIndex: 'time',
        key: 'time',
        width: '12%',
        sorter: (a, b) => dateToTimestamp(a.time) - dateToTimestamp(b.time),
        editable: true,
    },
    {
        title: '价位',
        type: 'string',
        dataIndex: 'price',
        key: 'price',
        width: '8%',
        sorter: (a, b) => a.price.split('_')[1] - b.price.split('_')[1],
        editable: true,
    },
    {
        title: '用户',
        type: 'array',
        dataIndex: 'customInfo',
        key: 'customInfo',
        width: '18%',
        // sorter: (a, b) => a.customInfo.split('_')[1] - b.customInfo.split('_')[1],
        editable: true,
    },
    {
        title: '购票成功',
        type: 'boolean',
        dataIndex: 'isFinish',
        key: 'isFinish',
        width: '8%',
        render: (text) => text ? text.toString() : 'false',
        sorter: (a, b) => Number(b.isMember) - Number(a.isMember),
        editable: true,
    },
    {
        title: '机器人',
        type: 'string',
        dataIndex: 'robots',
        key: 'robots',
        width: '12%',
        editable: true,
    },
    {
        title: '类型',
        type: 'string',
        dataIndex: 'type',
        key: 'type',
        width: '10%',
        editable: true,
    },
];